exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.margin-b-0[data-v-56bdca02]{margin-bottom: 0!important;\n}\r\n", "", {"version":3,"sources":["E:/lib/iview/src/yxUIComponent/custom/cModal.vue"],"names":[],"mappings":";AACA,6BAA6B,2BAA2B;CACvD","file":"cModal.vue","sourcesContent":["\n.margin-b-0[data-v-56bdca02]{margin-bottom: 0!important;\n}\r\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"id":"data-v-56bdca02","scoped":true,"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/yxUIComponent/custom/cModal.vue
// module id = 725
// module chunks = 0